module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/loans-mobile-4957634bd29cbe4de27dff492bdc6e48.png";